export const backendMode = import.meta.env.VITE_BACKEND_MODE === 'ionos' ? 'ionos' : 'demo'
export const isDemoMode = backendMode === 'demo'
export const apiBase = import.meta.env.VITE_API_BASE || '/api/index.php'
